import React from 'react';
import { Card, Box, HStack, Text } from '@chakra-ui/react';
import { HiCreditCard, HiChevronRight } from 'react-icons/hi';

interface ChargeMenuProps {
  onClick: () => void;
}

const ChargeMenu: React.FC<ChargeMenuProps> = ({ onClick }) => (
  <Card.Root w="full" variant="elevated" bg="white/80" borderRadius="2xl">
    <Card.Body p={0}>
      <Box
        as="button"
        w="full"
        py={3}
        px={4}
        onClick={onClick}
        _hover={{ bg: 'gray.50' }}
        transition="background 0.2s"
        borderRadius="2xl"
      >
        <HStack justify="space-between">
          <HStack gap={3}>
            <HiCreditCard className="text-gray-800" size={18} />
            <Text fontSize="sm" fontWeight="medium" color="gray.800">
              残高チャージ
            </Text>
          </HStack>
          <HiChevronRight className="text-gray-400" size={18} />
        </HStack>
      </Box>
    </Card.Body>
  </Card.Root>
);

export default ChargeMenu;
